import { Flex } from 'antd';
import { memo, useContext } from 'react';

import { Button, ButtonVariant, Grid, Modal } from '@/shared/ui';

import ModalContext from '@/contexts/Modal/ModalContext';

export interface SocialProtectAppealInfoAlertProps {
  fieldsToPreview: Array<[string, Nullable<string>]>;
}

const HEADER_TEXT = 'Інформація про заявку';

export const SocialProtectAppealInfoAlert = memo(function SocialProtectAppealInfoAlert({
  fieldsToPreview,
}: SocialProtectAppealInfoAlertProps) {
  const { toggleModal, isModalOpen } = useContext(ModalContext);

  return (
    <Modal
      size="md"
      title={HEADER_TEXT}
      open={isModalOpen}
      closable
      onCancel={(): void => toggleModal()}
      styles={{ body: { marginInline: -24 } }}
      footer={
        <Flex justify="flex-start">
          <Button variant={ButtonVariant.SECONDARY} onClick={(): void => toggleModal()}>
            Закрити вікно
          </Button>
        </Flex>
      }
    >
      <Grid data={fieldsToPreview} />
    </Modal>
  );
});
